import { Section } from "./section";

export const links = [
  {
    title: "Переваги",
    href: `#${Section.benefits}`,
  },

  {
    title: "Види пального",
    href: `#${Section.kindsGas}`,
  },
  {
    title: "Сертифікати",
    href: `#${Section.certificates}`,
  },
  {
    title: "Знайти нас",
    href: `#${Section.findUs}`,
  },
  {
    title: "Бонусна программа",
    href: `#${Section.bonuses}`,
  },
  {
    title: "FAQ",
    href: `#${Section.questions}`,
  },
  {
    title: "Контакти",
    href: `#${Section.contacts}`,
  },
]
